import React from 'react'
import { Text } from '@lightspeed/design-system-react'
import { formatCurrencyValue } from '@vend/utilities'
import { useT } from '@transifex/react'
import {
  useRegisterManager,
  useRetailerSettingsManager,
} from '../../../ng-compat/hooks'
import { useAppSelector } from '../../../state/hooks'
import {
  selectSaleTotals,
  selectLspCashDiscountPercentage,
} from '../../../state/slices/currentSale/currentSaleSlice'
import { useFormatPercentage } from '../../helpers/formatNumberHooks'

export const LspayCashDiscountRow: React.FC = () => {
  const saleTotals = useAppSelector(selectSaleTotals)
  const lspCashDiscountPercentage = useAppSelector(
    selectLspCashDiscountPercentage
  )
  const registerManager = useRegisterManager()
  const retailer = useRetailerSettingsManager().get()
  const currentOutlet = registerManager.getActiveOutlet()
  const formatPercentage = useFormatPercentage()
  const t = useT()
  const rate = lspCashDiscountPercentage

  return (
    <div className="sale-discount-line">
      <Text type="label">
        {t('Cash discount {rate}', {
          _context: 'LSPay cash discount line in sale footer',
          rate: formatPercentage(rate / 100),
        })}
      </Text>
      <div className="sale-total-line-item--value sale-discount-line-right">
        <Text type="label">
          <b>
            {formatCurrencyValue(
              saleTotals.lspCashDiscount,
              retailer.culture,
              currentOutlet.currency,
              currentOutlet.currency_symbol
            )}
          </b>
        </Text>
      </div>
    </div>
  )
}
